import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { colors, Typography, Button } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import { Section } from 'components/organisms';


const useStyles = makeStyles(theme => ({
  // root: {
  //   width: '100%',
  //   height: '100%',
  //   position: 'relative',
  //   background: theme.palette.alternate,
  //   overflow: 'hidden',
  // },
  // backgroiundImage: {
  //   minHeight: 400,
  //   objectFit: 'cover',
  //   [theme.breakpoints.down('sm')]: {
  //     width: 'auto',
  //     minHeight: 500,
  //   },
  // },
  root: {
    // background: `url(/images/landing/1_main_b_2.png) no-repeat bottom center, ${theme.palette.alternate}`,
    background: `url(/images/landing/mainbanner_final1.jpg) no-repeat center, ${theme.palette.alternate}`,
    backgroundSize: 'cover',
    paddingTop: theme.spacing(5),
    [theme.breakpoints.only('xs')]: {
      backgroundPosition: '40%',
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(8),
      // minHeight: 600,
    },
    [theme.breakpoints.up('xl')]: {
      minHeight: 650,
    },
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  hero: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    minHeight: 470,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  section: {
    paddingTop: 0,
  },
  sectionHeader: {
    padding: theme.spacing(0, 2),
    maxWidth: '60%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '49%',
      // width: 'calc(100vw - 625px)',
    },
  },
  textWhite: {
    color: 'white',
  },
  textBlue: {
    color: theme.palette.primary.main,
  },
  textGray: {
    color: theme.palette.primary.main,
  },
  image: {
    alignSelf: 'flex-end',
    maxWidth: 625,
    height: 'auto',
    
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      top: '50%',
      right: 0,
      width: 'auto',
      transform: 'translateY(-50%) !important',
    },
    [theme.breakpoints.up('xl')]: {
      right: 200,
    },
  },
}));

const Hero = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  
  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <div className={classes.hero}>
        <Section className={classes.section} disablePadding>
          <div className={classes.sectionHeader}>
            <Typography variant="h5" gutterBottom className={classes.textBlue} data-aos="fade-up">
              Reach their fullest academic & personal potential
            </Typography>
            <SectionHeader
              titleVariant="h2"
              title={
                <span className="text-highlighted__primary">
                  Customized Programs
                </span>
              }
              subtitleVariant="h5"
              subtitle={
                <span className="text-highlighted__secondary">
                  Our curriculum is customized for each student's 
                  schedule, needs, and challenges.
                </span>
              }
              align="left"
              data-aos="fade-up"
            />
            <Button variant="contained" size="large" color="secondary" 
              href="/admissions"
              data-aos="fade-up"
            >
              GET STARTED
            </Button>
          </div>
        </Section>
        {/* <br />
        <Image
          src="/images/landing/1_main_notebook.png"
          className={classes.image}
          data-aos="fade-up"
          lazy={false}
        /> */}
      </div>
    </div>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
